import cx from 'classnames';
import { useContext } from 'react';
import HideOnNative from '@/srp/HideOnNative';
import { StickySearchContext } from '@/srp/Search/components/StickySearchProvider';
import { usePagination } from '@/srp/SearchResults/hooks';
import TitleTag from '@/srp/SEO/TitleTag';
import styles from './SearchHeader.module.css';
import { Header, StickyWrapper } from './SearchHeader.styles';
import { SearchBar } from '../SearchHeader/SearchBar';

export default function SearchHeader() {
  const {
    pagination: { totalMatchedInventory = 0 }
  } = usePagination();

  const { isStickySearchBar } = useContext(StickySearchContext);

  return (
    <StickyWrapper
      className={cx({
        [styles['is-sticky']]: isStickySearchBar
      })}
      data-qa="search-bar"
      id="search-wrapper"
    >
      <HideOnNative>
        <Header className={cx({ hidden: isStickySearchBar })}>
          <TitleTag />
          <p className="tl-body-xs" data-qa="results-count">
            {totalMatchedInventory.toLocaleString()} results
          </p>
        </Header>
      </HideOnNative>
      <SearchBar isStickySearchBar={isStickySearchBar} />
    </StickyWrapper>
  );
}
